import PropTypes from "prop-types";
import React, { useCallback, useEffect } from "react";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "../Common/withRouter";
import { Link, useLocation } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {getAllInformation} from "../../store/Information/actions";

const SidebarContent = props => {
  const dispatch = useDispatch();
  // const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      // scrollElement(item);
      return false;
    }
    // scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  // useEffect(() => {
  //   ref.current.recalculate();
  // }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    dispatch(getAllInformation())
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  // function scrollElement(item) {
  //   if (item) {
  //     const currentPosition = item.offsetTop;
  //     if (currentPosition > window.innerHeight) {
  //       ref.current.getScrollElement().scrollTop = currentPosition - 300;
  //     }
  //   }
  // }

  const information = useSelector((state) => state.Information.info);
  const candidateRole = useSelector((state) => state.Authorisation.candidate.role);
  return (
    <React.Fragment>

      <SimpleBar style={{ maxHeight: "100%" }}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>
            <li>
              <Link to="/dashboard" className="waves-effect">
                <i className="uil-home-alt"></i>

                <span>მთავარი</span>
              </Link>
            </li>

            {
              candidateRole === 'admin' &&
                  <>
                    <li className="menu-title">ადმინები</li>
                    <li>
                      <Link to="/admins" className="waves-effect">
                        <i className="bx bx-fingerprint "></i>
                        <span>დამატება</span>
                      </Link>
                    </li>

                    <li>
                      <Link to="/admins" className="waves-effect">
                        <i className="bx bx-list-ul"></i>
                        <span>სია</span>
                      </Link>
                    </li>
                  </>
            }

            {
              (candidateRole === 'admin' || candidateRole === 'sell'  || candidateRole === 'logistic' ) &&
                  <>
                    <li className="menu-title">კომპანიები</li>
                    <li>
                      <Link to="/create-company" className="waves-effect">
                        <i className="bx bx-add-to-queue"></i>
                        <span>დამატება</span>
                      </Link>
                    </li>

                    <li>
                      <Link to="/list-company" className="waves-effect">
                   <span className="badge rounded-pill bg-primary float-end">
                   {information.company}
                </span>
                        <i className="bx bxs-business"></i>
                        <span>სია</span>
                      </Link>
                    </li>

                    <li className="menu-title">AWB / Truck</li>
                    <li>
                      <Link to="/create-awb" className="waves-effect">
                        <i className="bx bxs-file-plus"></i>
                        <span>დამატება</span>
                      </Link>
                    </li>

                    <li>
                      <Link to="/list-awb" className="waves-effect">
                        <i className="bx bxs-plane-alt"></i>
                        <span>სია</span>
                      </Link>
                    </li>

                  </>
            }


            <li>
              <Link to="/notifications" className="waves-effect">
                <i className="uil-bell"></i>
                <span>შეტყობინებები</span>
              </Link>
            </li>



            <li className="menu-title">შეკითხვის ფორმირება</li>
            {
              (candidateRole === 'admin' || candidateRole === 'sell'  || candidateRole === 'logistic' ) &&
                  <>

                    <li>
                      <Link to="/create-question" className="waves-effect">
                        <i className="bx bxs-plus-circle"></i>
                        <span>შეკითხვის დამატება</span>
                      </Link>
                    </li>


                    <li>
                      <Link to="/list-logistic/waiting" className="waves-effect">
                        <i className="bx bx-loader-circle"></i>
                        <span className="badge rounded-pill bg-primary float-end">
                  {information.waiting}
                </span>
                        <span>მოლოდინის რეჟიმი</span>
                      </Link>
                    </li>

                    <li>
                      <Link to="/list-logistic/tariffIssued" className="waves-effect">
                        <i className="bx bx-dollar"></i>
                        <span className="badge rounded-pill bg-primary float-end">
                  {information.tariffIssued}
                </span>
                        <span>ტარიფი გაცემულია</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/list-logistic/confirmed" className="waves-effect">
                        <i className="bx bx-check-square"></i>
                        <span className="badge rounded-pill bg-primary float-end">
                    {information.confirmed}
                </span>
                        <span>დადასტრუდა</span>
                      </Link>
                    </li>



                    <li>
                      <Link to="/list-logistic/organizeLoad" className="waves-effect">
                        <i className="bx bx-shekel"></i>
                        <span className="badge rounded-pill bg-primary float-end">
                  {information.organizeLoad}
                </span>
                        <span>ტვ. ორგანიზება</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/list-logistic/domesticShipping" className="waves-effect">
                        <i className="bx bxs-truck"></i>
                        <span className="badge rounded-pill bg-primary float-end">
                   {information.domesticShipping}
                </span>
                        <span>შიდა გადაზიდვა</span>
                      </Link>
                    </li>



                    <li>
                      <Link to="/list-logistic/stock" className="waves-effect">
                        <i className=" bx bxs-package"></i>
                        <span className="badge rounded-pill bg-primary float-end">
                   {information.stock}
                </span>
                        <span>საწყობშია</span>
                      </Link>
                    </li>


                    <li>
                      <Link to="/list-logistic/AWB" className="waves-effect">
                        <i className="bx bxs-paper-plane "></i>
                        <span className="badge rounded-pill bg-primary float-end">
                  {information.AWB}
                </span>
                        <span>AWB / Truck</span>
                      </Link>
                    </li>

                    <li>
                      <Link to="/list-logistic/instruction" className="waves-effect">
                        <i className="bx bx-customize"></i>
                        <span className="badge rounded-pill bg-primary float-end">
                  {information.instruction}
                </span>
                        <span>ინსტრუქცია</span>
                      </Link>
                    </li>


                    <li>
                      <Link to="/list-logistic/declaration" className="waves-effect">
                        <i className="bx bx-file"></i>
                        <span className="badge rounded-pill bg-primary float-end">
                  {information.declaration}
                </span>
                        <span>დეკლარაცია</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/list-logistic/courier" className="waves-effect">
                        <i className="bx bxs-car"></i>
                        <span className="badge rounded-pill bg-primary float-end">
                  {information.courier}
                </span>
                        <span>საკურიერო</span>
                      </Link>
                    </li>

                    <li>
                      <Link to="/list-logistic/archive" className="waves-effect">
                        <i className="bx bx-archive"></i>
                        <span className="badge rounded-pill bg-primary float-end">
                   {information.archive}
                </span>
                        <span>არქივი</span>
                      </Link>
                    </li>

                    <li>
                      <Link to="/list-logistic/reject" className="waves-effect">
                        <i className="bx bx-block"></i>
                        <span className="badge rounded-pill bg-primary float-end">
                   {information.reject}
                </span>
                        <span>უარი</span>
                      </Link>
                    </li>

                  </>
            }




            {
               candidateRole === 'declarant'  &&
                   <>
                     <li>
                       <Link to="/list-logistic/instruction" className="waves-effect">
                         <i className="bx bx-customize"></i>
                         <span className="badge rounded-pill bg-primary float-end">
                  {information.instruction}
                </span>
                         <span>ინსტრუქცია</span>
                       </Link>
                     </li>


                     <li>
                       <Link to="/list-logistic/declaration" className="waves-effect">
                         <i className="bx bx-file"></i>
                         <span className="badge rounded-pill bg-primary float-end">
                  {information.declaration}
                </span>
                         <span>დეკლარაცია</span>
                       </Link>
                     </li>
                   </>
            }


          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
